import { PasswordValidation } from './../password-validation/password-validation.component';
import { UsersService } from './../services/users.service';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
	selector: 'app-account-modification-pwd',
	templateUrl: './account-modification-pwd.component.html',
	styleUrls: ['./account-modification-pwd.component.scss']
})
export class AccountModificationPwdComponent implements OnInit {

	@BlockUI() blockUI: NgBlockUI;
	@Input() id: string;

	email: string = "";
	inputPwdFocus: boolean = false;
	form: FormGroup;

	constructor(
		public activeModal: NgbActiveModal,
		private toastrService: ToastrService,
		private authService: AuthService,
		private usersService: UsersService,
		private formBuilder: FormBuilder,
	) { }

	ngOnInit(): void {
		this.getUserById();
		this.form = this.formBuilder.group({
			oldPassword: ['', Validators.required],
			password: ['', [Validators.required, Validators.maxLength(30)]],
			confirmedPassword: ['', Validators.required]
		}, {
			validator: PasswordValidation.MatchPassword
		});
	}

	// get user infos by id
	getUserById(): void {
		this.blockUI.start('Loading');
		this.usersService.getCoreUserById(this.id).subscribe(
			(res) => {
				if (res.success) {
					this.email = res.data.email;
					this.blockUI.stop();
				} else {
					this.blockUI.stop();
					if (res.errorSet.includes('InvalidRequest')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('NotFound')) {
						this.toastrService.error('Utilisateur non trouvé');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}

	saveModification(): void {
		this.blockUI.start('Loading');
		const data = {
			email: this.email,
			pass: this.form.controls.oldPassword.value,
		}

		this.authService.verifyLogin(data).subscribe(
			(res) => {
				if (res.success) {
					if (this.form.controls.password.value === this.form.controls.confirmedPassword.value) {
						const data = {
							jwt: localStorage.getItem('token'),
							pass: this.form.controls.password.value
						};

						this.usersService.updatePassByUser(data).subscribe(
							(res) => {
								if (res.success) {
									this.toastrService.success('Mise à jour');
									this.blockUI.stop();
									this.activeModal.close();
								} else {
									this.blockUI.stop();
									if (res.errorSet.includes('INVALID_PARAMS') || res.errorSet.includes('INVALID_REQUEST')) {
										this.toastrService.error('Les paramètres sont invalides');
									} else if (res.errorSet.includes('ERROR_SERVER') || res.errorSet.includes('SERVER_ERROR')) {
										this.toastrService.error('Une erreur de serveur');
									}
								}
							},
							(error) => {
								this.blockUI.stop();
								// console.error(error);
								this.toastrService.error('Une erreur s\'est produite');
							}
						)
					}
					this.blockUI.stop();
				} else {
					this.blockUI.stop();
					if (res.errorSet.includes('INVALID_PARAMS') | res.errorSet.includes('INVALID_REQUEST')) {
						this.toastrService.error('Les paramètres sont invalides');
					} else if (res.errorSet.includes('EMAIL_NOT_EXIST')) {
						this.toastrService.error(`Email n'existe pas`);
					} if (res.errorSet.includes("INCORRECT_PASSWORD")) {
						this.toastrService.error(`Mot de passe actuel erroné`);
					} else if (res.errorSet.includes('ERROR_SERVER') | res.errorSet.includes('SERVER_ERROR')) {
						this.toastrService.error('Une erreur de serveur');
					}
				}
			},
			(error) => {
				this.blockUI.stop();
				// console.error(error);
				this.toastrService.error('Une erreur s\'est produite');
			}
		);
	}
}
